import React from 'react';
import Hero from '../components/UI/Hero';
import heroImage from '../assets/optimized/asset9.webp';
import './ContactPage.css';

const ContactPage = () => {
  return (
    <div className="contact-page">
      <Hero
        image={heroImage}
        title="Get in Touch"
        subtitle="Have a question or want to work together? We'd love to hear from you."
        size="medium"
      />

      <section className="contact-section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2 className="contact-info-title">Let's Talk</h2>
              <p className="contact-info-desc">
                Whether you have a project idea, need support for one of our products,
                or just want to say hello, fill out the form and we'll get back to you.
              </p>

              <div className="contact-details">
                <div className="contact-detail">
                  <div>
                    <h4>Email</h4>
                    <p>ivargavelin@gmail.com</p>
                  </div>
                </div>

                <div className="contact-detail">
                  <div>
                    <h4>Location</h4>
                    <p>Stockholm, Sweden</p>
                  </div>
                </div>
              </div>

              <div className="contact-social">
                <h4>Follow Us</h4>
                <div className="social-links">
                  <a href="https://github.com/Ivargavve" target="_blank" rel="noopener noreferrer" aria-label="GitHub">GitHub</a>
                  <a href="https://www.linkedin.com/company/aerocapture-productions-ekonomisk-f%C3%B6rening/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">LinkedIn</a>
                  <a href="https://www.youtube.com/@aerocapturep" target="_blank" rel="noopener noreferrer" aria-label="YouTube">YouTube</a>
                  <a href="https://www.instagram.com/aerocaptureproduction/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">Instagram</a>
                </div>
              </div>
            </div>

            <div className="contact-form-container">
              <form
                className="contact-form"
                action="https://formsubmit.co/37963975c18a537aa61345160a069f5b"
                method="POST"
              >
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Your name"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="your@email.com"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    placeholder="What is this about?"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    rows={5}
                    placeholder="Your message..."
                    required
                  ></textarea>
                </div>

                <input type="hidden" name="_captcha" value="false" />
                <input type="hidden" name="_template" value="table" />

                <button type="submit" className="submit-btn">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
